var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"font-light text-gray-500 w-full leading-8 text-lg md:text-center py-16 pl-8 md:pl-0",attrs:{"data-aos":"zoom-in"}},[_vm._v(" © "+_vm._s(_vm.currentYear)+" Mikołaj Mirko ")])
}
var staticRenderFns = []

export { render, staticRenderFns }